import handler from 'api/handler'

const prefix = '/admin/featuredPlacement'

const methods = {
  create: args => handler({ method: 'post', url: prefix + '/create', args, isFile: true }),
  update: (id, args) => handler({ method: 'put', url: prefix + `/update/${id}`, args, isFile: true }),
  delete: id => handler({ method: 'delete', url: prefix + `/delete/${id}` }),
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  toggleVisibility: args => handler({ method: 'patch', url: prefix + '/toggle-visibility', args })
}

export default methods
